import "./responseui.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SuccessToast } from "../../../utils/commonunctions";
import { useDispatch, useSelector } from "react-redux";
import {
  conversationByIdAPI,
  modifyResponseApi,
} from "../../../redux/action/UserAction";
import { userSelector } from "../../../redux/slices/userSlice";
import Loader from "../../../components/loader";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ModifySuggestion from "../../../components/suggestion/modifySuggestion";
import { formatResponseText } from "../../../utils/helperdata";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

const ResponseUi = () => {
  // Accessing navigation state and setting defaults
  const location = useLocation();
  let isHistory = location?.state?.isHistory ?? false;
  let id = location?.state?.id;
  let showres = location?.state?.showres;
  let newQuery = location?.state?.newQuery ?? false;

  // State declarations
  const [ismodify, setIsModify] = useState(newQuery);
  const [response, setResponse] = useState("");
  const [query, setQuery] = useState();
  const [data] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [suggestionValue, setSuggestionValue] = useState();
  const [showResponse, setShowResponse] = useState(showres);
  const [convoId, setConvoId] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get conversation data from Redux
  const { conversationById, modifyLoading } = useSelector(userSelector);

  let newId = convoId?.length <= 0 ? id : convoId;

  // Fetch conversation by ID on component load
  useEffect(() => {
    dispatch(conversationByIdAPI(id, isHistory, setIsLoading));
  }, [id, isHistory]);

  // Populate query and response details once conversation data is available
  useEffect(() => {
    setQueries();
  }, [id, isHistory, conversationById]);

  // Set query, response, and suggestion values
  const setQueries = () => {
    const queries = conversationById?.queries || [];
    const firstQuery = queries[0];
    setConvoId(queries?.map((e) => e?.id));

    if (queries?.length > 0) {
      const responseText =
        firstQuery?.modified_response || firstQuery?.response;

      setResponse(formatResponseText(responseText));
      setSuggestionValue(firstQuery?.options);
      setQuery(firstQuery?.query);
    } else {
      setResponse(formatResponseText(conversationById?.response));
      setSuggestionValue(firstQuery?.options);
      setQuery(firstQuery?.query);
    }
  };

  // Handle copy to clipboard functionality
  const handleCopy = () => {
    navigator.clipboard
      .writeText(response)
      .then(() => {
        SuccessToast("Copied To Clipboard!");
      })
      .catch((err) => {});
  };

  // Handle modification API call
  const modifyResponse = async (formikvalues) => {
    setIsModify(true);

    let modifyValue = {
      generated_prompt: query,
      input_for_modification: formikvalues,
      response_from_gpt: response ? response : data?.data?.response,
    };

    dispatch(
      modifyResponseApi(
        newId,
        modifyValue,
        setResponse,
        setIsLoading,
        formatResponseText
      )
    );
  };

  // Navigate back to dashboard
  const handleBack = () => {
    navigate("/");
  };

  return (
    <>
      <div style={{ padding: "50px" }}>
        {/* Breadcrumb navigation */}
        <div
          style={{
            display: "flex",
            padding: "0px 0px 10px 0px",
            cursor: "pointer",
          }}
        >
          <Breadcrumbs aria-label="breadcrumb">
            <div onClick={handleBack}>
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
              Dashboard
            </div>
            <Typography
              sx={{
                color: "text.primary",
                display: "flex",
                alignItems: "center",
              }}
            >
              Response
            </Typography>
          </Breadcrumbs>
        </div>

        {/* Display query */}
        <div className="responseuiinputcontainer">
          {query ? (
            <AccountCircleIcon
              className="response-input-icon"
              style={{ background: "initial" }}
            />
          ) : null}
          {query ? (
            <p className="responseuiinput">{query ?? ""}</p>
          ) : null}
        </div>

        {/* Response section with copy button */}
        <div className="response-header">
          <p>Response</p>
          <div
            className="copycontainer"
            style={{ display: "flex", cursor: "pointer", alignItems: "center" }}
            onClick={handleCopy}
          >
            <ContentCopyOutlinedIcon /> <p>Copy Response</p>
          </div>
        </div>

        {/* Response text or loader */}
        <div className="responsetextdiv">
          {isLoading || modifyLoading ? (
            <Loader />
          ) : (
            <p
              className="responestyle"
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: response,
              }}
            />
          )}
        </div>

        {/* Modify suggestion form */}
        <div style={{ marginTop: "4%" }}>
          <ModifySuggestion
            isClass={false}
            onModifyClick={modifyResponse}
            suggestionValue={suggestionValue}
            setSuggestionValue={setSuggestionValue}
            setShowResponse={setShowResponse}
            showResponse={showResponse}
            resdata={data}
            setIsModify={setIsModify}
            ismodify={ismodify}
            conversationById={conversationById}
          />
        </div>
      </div>
    </>
  );
};

export default ResponseUi;
